import { UAParser } from 'ua-parser-js'

const { device } = new UAParser().getResult()
const isMobile = ['mobile', 'tablet'].includes(device.type)

export default function (phone, message) {
  const userAgent = navigator.userAgent
  const iOS = !!userAgent.match(/iPhone|iPad|iPod/)

  const text = encodeURIComponent(message)

  const api = isMobile ? 'https://api.whatsapp.com' : 'https://web.whatsapp.com'
  const url = `${api}/send?phone=55${phone}&text=${text}`

  if (isMobile) {
    if (iOS) {
      openLinkExternally(url)
    } else {
      window.open(url)
    }
  } else {
    openLinkInNewTab(url)
  }
}

const openLinkInNewTab = url => {
  if (typeof document === 'undefined') return // Not on a browser!
  const win = window.open(url, '_blank')
  win.focus()
}

const openLinkExternally = (url) => {
  // Cria um elemento <a> temporário para simular um clique direto do usuário
  const a = document.createElement('a')
  a.href = url
  a.target = '_blank' // Abre o link em uma nova aba
  a.rel = 'noreferrer noopener' // Previne problemas de segurança

  // Simula um clique no elemento
  document.body.appendChild(a)
  a.click()

  // Limpa o elemento temporário
  document.body.removeChild(a)
}



// WEBPACK FOOTER //
// ./src/services/sendMessageWPP.js